import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { 
	AppDispatch,
	RootState, 
} from '@/store/store';

import { storeNoticesDismiss } from '@/actions/store';

import WebsiteNotice from '@/models/WebsiteNotice';

const useNotice = (position: string) => {
  
	// Dispatch
	const dispatch = useDispatch<AppDispatch>();

	// Redux state
	const notices: WebsiteNotice[] = useSelector((state: RootState) => state.store.notices);
	const dismissedNotices: string[] = useSelector((state: RootState) => state.store.noticesDismissed);

	// Local state for hydration handling
	const [hydratedNotice, setHydratedNotice] = useState<WebsiteNotice | null>(null);

	// Function to dismiss a notice
	const dismissNotice = () => {
		dispatch(storeNoticesDismiss(position));
	};

	// Effects
	useEffect(() => {
		const initialNotice = position && !dismissedNotices.includes(position)
			? notices.find((nt) => nt.position === position) || null
			: null;

		setHydratedNotice(initialNotice);
	}, [position, notices, dismissedNotices]);

	return {
		notice: hydratedNotice,
		dismissNotice,
	};
};
export default useNotice;